import * as rudderanalytics from 'rudder-sdk-js';
const rudderInitialize = async () => {
  if (
    process.env.REACT_APP_RUDDER_WRITE_KEY &&
    process.env.REACT_APP_RUDDER_DATA_PLANE_URL
  ) {
    await rudderanalytics.load(
      process.env.REACT_APP_RUDDER_WRITE_KEY,
      process.env.REACT_APP_RUDDER_DATA_PLANE_URL,
      {
        logLevel: 'DEBUG',
        integrations: { All: true },
      }
    );
  }

  return new Promise((resolve) => {
    rudderanalytics.ready(resolve as () => void);
  });
};

const rudderIdentify = async (userId: string, data: any) => {
  if (!rudderanalytics) {
    await rudderInitialize();
  }

  return new Promise((resolve) => {
    rudderanalytics.identify(userId, data, undefined, resolve as () => void);
  });
};

const rudderVisitPage = async (
  page: string,
  properties: Record<string, string | number> = {}
): Promise<void> => {
  return new Promise((resolve) => {
    rudderanalytics.page(page, properties, resolve);
  });
};

const rudderTrack = async (eventName: string, data: any) => {
  if (!rudderanalytics) {
    await rudderInitialize();
  }

  return new Promise((resolve) => {
    rudderanalytics.track(eventName, data, undefined, resolve as () => void);
  });
};

const rudderTrackGroup = async (groupId: string, data: any) => {
  if (!rudderanalytics) {
    await rudderInitialize();
  }

  return new Promise((resolve) => {
    rudderanalytics.group(groupId, data, undefined, resolve as () => void);
  });
};

const rudderReset = async (): Promise<void> => {
  rudderanalytics.reset();
};

export {
  rudderanalytics,
  rudderInitialize,
  rudderIdentify,
  rudderVisitPage,
  rudderTrack,
  rudderTrackGroup,
  rudderReset,
};
